import { isNaN, isNil, isNumber as checkNumber, isString as checkString } from 'lodash-es';

export const isExist = <T>(value: T | null | undefined): value is NonNullable<T> => isNil(value) === false;

export const isString = (value?: string | null | undefined, isTrimmed = false): value is NonNullable<string> =>
  checkString(value) && (isTrimmed ? value.trim() : value).length > 0;

export const isNumber = (value?: number | null | undefined): value is NonNullable<number> =>
  checkNumber(value) && !isNaN(value);
